// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4441 ? "b9da0acd" : chunkId) + "." + {"4441":"cd878b1bb4076752","5789":"d0e59873354b18bf","5864":"995642bf59e9ccce"}[chunkId] + ".js";
};